import { render } from "./BlockDisplayWrap.vue?vue&type=template&id=52fd162f&scoped=true&ts=true"
import script from "./BlockDisplayWrap.vue?vue&type=script&lang=ts"
export * from "./BlockDisplayWrap.vue?vue&type=script&lang=ts"

import "./BlockDisplayWrap.vue?vue&type=style&index=0&id=52fd162f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fd162f"]])

export default __exports__